var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.306,
    height: 58.007,
    viewBox: "0 0 198.306 58.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-198.485 -31.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "yEBjTQ.tif"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M352.3,56.833c0-4.812.006-9.624-.011-14.436,0-.45.067-.61.574-.606,3.545.026,7.09.02,10.634.012a10.363,10.363,0,0,1,8.773,4.242,9.6,9.6,0,0,1,1.939,6.87,9.988,9.988,0,0,1-6.031,8.526,10.872,10.872,0,0,1-4.728.971c-1.265,0-2.53.016-3.794-.008-.4-.008-.517.112-.514.512.016,2.807,0,5.614.02,8.421,0,.444-.126.526-.54.521-1.935-.023-3.871-.026-5.8,0-.439.007-.529-.113-.528-.534C352.308,66.494,352.3,61.664,352.3,56.833Zm6.844-4.735c0,1.145.015,2.29-.009,3.435-.009.388.122.482.492.477,1.341-.021,2.682,0,4.022-.011a3.809,3.809,0,0,0,1.4-.243,3.965,3.965,0,0,0,2.3-4.453,3.612,3.612,0,0,0-3.7-3.086c-1.36-.02-2.72.008-4.079-.013-.364,0-.449.117-.443.458C359.158,49.807,359.146,50.953,359.146,52.1Z",
    fill: "#07113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M341.713,69.84a7.471,7.471,0,0,1-3.565,2.231,9.909,9.909,0,0,1-11.254-4.343,12.267,12.267,0,0,1,.7-14.168,9.878,9.878,0,0,1,11.723-2.924,7.5,7.5,0,0,1,1.231.724c.381.273.717.61,1.169,1,0-.6.014-1.1-.006-1.607-.011-.274.076-.357.353-.355,1.917.011,3.833.017,5.749,0,.413,0,.348.23.348.473q0,2.951,0,5.9c0,4.832-.007,9.664.012,14.495,0,.469-.1.6-.585.594-1.8-.033-3.6-.024-5.4,0-.367,0-.5-.08-.475-.465C341.74,70.927,341.713,70.459,341.713,69.84Zm-5.137-3.455a4.89,4.89,0,0,0,5.137-5.264,5.153,5.153,0,1,0-10.3.017A4.891,4.891,0,0,0,336.576,66.385Z",
    fill: "#07113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M381.211,63.694a3.739,3.739,0,0,0,1.677,2.164,6.43,6.43,0,0,0,6.852-.111,1.452,1.452,0,0,1,1.907-.024c1.185.764,2.436,1.427,3.671,2.112.307.17.366.276.126.578a10.225,10.225,0,0,1-6.681,3.85,13.907,13.907,0,0,1-7.234-.618,10.5,10.5,0,0,1-6.948-8.384,11.611,11.611,0,0,1,.732-6.772,10.285,10.285,0,0,1,7.324-6.274c4.529-1.1,8.551-.157,11.648,3.529a10.931,10.931,0,0,1,2.479,6.506,15.17,15.17,0,0,1-.1,2.857c-.053.419-.173.6-.658.6-4.694-.022-9.389-.013-14.083-.013Zm4.528-4.781h4.072c.64,0,.646-.011.4-.631a4.624,4.624,0,0,0-5-2.8,4.381,4.381,0,0,0-4,3c-.14.391-.019.442.34.438C382.947,58.9,384.343,58.913,385.739,58.913Z",
    fill: "#07113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M271.978,52.226a7.416,7.416,0,0,1,4.032-2.206c3.5-.68,6.695.231,8.666,3.119a9.761,9.761,0,0,1,1.542,5.644c.012,4.181,0,8.362.015,12.543,0,.44-.123.538-.546.532q-2.672-.036-5.345,0c-.434.006-.571-.088-.568-.551.021-3.837.01-7.675.013-11.512a3.77,3.77,0,0,0-5.2-3.9,3.446,3.446,0,0,0-2.5,2.908,7.862,7.862,0,0,0-.11,1.539c0,3.665-.009,7.331.012,11,0,.439-.116.529-.536.523q-2.73-.036-5.46,0c-.384,0-.466-.111-.465-.476q.015-10.252,0-20.5c0-.363.077-.485.465-.48,1.858.021,3.717.017,5.575,0,.32,0,.436.078.416.409C271.958,51.279,271.978,51.753,271.978,52.226Z",
    fill: "#07113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M297.958,72.435a11.078,11.078,0,0,1-5.87-1.384,8.436,8.436,0,0,1-3.2-3.352c-.127-.231-.135-.341.124-.485q2.526-1.407,5.031-2.852c.217-.126.291-.074.374.123.949,2.272,2.891,2.4,4.662,2.142.781-.113,1.174-.526,1.218-1.091.043-.549-.252-.921-1-1.221-1.365-.544-2.815-.816-4.2-1.3a10.591,10.591,0,0,1-3.341-1.718,5.589,5.589,0,0,1-1.971-5.378c.439-3.358,2.647-5.1,5.725-5.818a10.32,10.32,0,0,1,7.968,1.137,9.513,9.513,0,0,1,2.887,2.826c.166.241.1.345-.135.47-1.636.867-3.271,1.734-4.89,2.63-.326.18-.374-.009-.5-.2a3.079,3.079,0,0,0-3.563-1.408,1.094,1.094,0,0,0-.925.956,1.006,1.006,0,0,0,.689,1.07,17.133,17.133,0,0,0,3.1.975,12.935,12.935,0,0,1,4.483,1.946A5.869,5.869,0,0,1,306.9,66c-.286,3.632-2.82,5.465-6.132,6.192A11.949,11.949,0,0,1,297.958,72.435Z",
    fill: "#07113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M311.889,61.627c0-1.741-.015-3.155.01-4.567.007-.409-.124-.52-.519-.508-.842.027-1.686,0-2.529.014-.325.006-.427-.108-.424-.432q.02-2.692,0-5.385c0-.28.087-.354.358-.349.824.016,1.651-.034,2.471.02.561.037.662-.175.644-.673-.036-.992,0-1.986-.017-2.979-.007-.327.064-.505.414-.605q2.8-.8,5.588-1.657c.4-.124.444.008.441.356-.013,1.68.006,3.36-.014,5.041-.005.387.08.524.5.514,1.168-.03,2.338,0,3.506-.018.315,0,.423.07.419.4q-.024,2.664,0,5.328c.005.379-.148.439-.473.436-1.168-.014-2.338.01-3.506-.015-.362-.007-.446.1-.443.448.015,2.349,0,4.7.012,7.046.007,1.326.446,1.766,1.792,1.974a10.505,10.505,0,0,0,2.234.057c.31-.017.384.062.382.362-.013,1.68-.006,3.36-.007,5.041,0,.183.051.366-.255.392-2.507.214-5.015.378-7.383-.717-2.016-.933-2.789-2.7-3.072-4.765A44.856,44.856,0,0,1,311.889,61.627Z",
    fill: "#07113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M255.4,56.828c0-4.812.007-9.625-.011-14.437,0-.463.089-.608.583-.6,1.935.032,3.871.025,5.806,0,.408,0,.506.115.505.511q-.015,14.523,0,29.046c0,.4-.1.51-.506.505-1.955-.021-3.91-.025-5.864,0-.443.006-.525-.121-.524-.537C255.409,66.492,255.4,61.66,255.4,56.828Z",
    fill: "#07113d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M237.753,34.558a21.556,21.556,0,0,0-8.676-2.663c-4.854-.5-9.734-.444-14.6-.589-4.7-.14-8.038,2.609-8.878,7.26q-3.115,17.247-6.219,34.5c-.083.46-.123.927-.184,1.391a9.672,9.672,0,0,1,6.162-3.331,51.225,51.225,0,0,1,9.474-1.046l2.4-13.207h-8.846l16.805-16.959,12.535,16.8h-9.038l-2.023,11.584.214-.046c10.44-2.427,16.185-8.437,17.7-18.569C245.555,43.1,243.107,37.638,237.753,34.558Z",
    fill: "#216fb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M214.828,70.08a3.035,3.035,0,0,1-1.709.527c-2.511.295-5.033.506-7.518,1a10.459,10.459,0,0,0-5.293,2.422c-.3.28-.628.589-1.116.423-.205,1.01-.441,2.015-.609,3.031a7.345,7.345,0,0,0,14.463,2.563c.6-3.207,1.155-6.424,1.726-9.637h-.005Z",
    fill: "#42bfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M200.308,74.031a10.459,10.459,0,0,1,5.293-2.422c2.485-.5,5.007-.707,7.518-1a3.035,3.035,0,0,0,1.709-.527v0a51.225,51.225,0,0,0-9.474,1.046,9.672,9.672,0,0,0-6.162,3.331C199.68,74.62,200.007,74.311,200.308,74.031Z",
    fill: "#42bfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M214.832,70.077l0,0-.061.331h.005l.06-.334Z",
    fill: "#07113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M214.832,70.077h0v0Z",
    fill: "#07113d"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Conscience_Lending",
    "data-name": "Conscience Lending",
    transform: "translate(277.64 87.308)",
    fill: "#07113d",
    fontSize: 11.122,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conscience Lending")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6bea1b038a4eaba1d50c56395ff3adb2.svg";
export { ForwardRef as ReactComponent };